import { REGULAR_TRANSLATIONS } from '~shared/constants/translations.constant';
import { ICONS_NAMES } from '~shared/constants/icons.constant';

import { IAccountDetailsSection } from '../models/account-info.model';

export const enum NOTIFICATIONS {
  passwordChanged = 'PAGES.ACCOUNT.INFO.PASSWORD_CHANGED_MESSAGE',
  accountInfoSaved = 'PAGES.ACCOUNT.INFO.SAVED_MESSAGE',
  accountInfoWithoutChanges = 'PAGES.ACCOUNT.INFO.WITHOUT_CHANGES_MESSAGE',
  accountInfoAdded = 'PAGES.ACCOUNT.INFO.ADDED_BUSINESS_INFO_MESSAGE',
}

export const ACCOUNT_INFO_PAGE_ALIAS = 'account-info';

export const enum AccountInfoSection {
  businessInfo = 'businessInfo',
  privateInfo = 'privateInfo',
  cardNumber = 'cardNumber',
  email = 'email',
  password = 'password',
}

export const CONSUMER_ACCOUNT_INFO_SECTION_LIST = [
  AccountInfoSection.privateInfo,
  AccountInfoSection.email,
  AccountInfoSection.password,
];

export const ENTREPRENEUR_ACCOUNT_INFO_SECTION_LIST = [
  AccountInfoSection.businessInfo,
  AccountInfoSection.email,
  AccountInfoSection.password,
];

export const METRO_CARD_ACCOUNT_INFO_SECTION_LIST = [
  AccountInfoSection.businessInfo,
  AccountInfoSection.cardNumber,
  AccountInfoSection.email,
  AccountInfoSection.password,
];

export const ACCOUNT_INFO_SECTIONS: { [key: string]: IAccountDetailsSection } = {
  [AccountInfoSection.privateInfo]: {
    testId: 'ACCOUNT_INFO_PAGE.PRIVATE_INFO',
    template: 'private-info',
    title: 'PAGES.ACCOUNT.INFO.PRIVATE_INFO',
    link: './edit-private-info',
    linkText: REGULAR_TRANSLATIONS.change,
    linkIcon: ICONS_NAMES.editSmall,
    linkAlignment: 'center',
    data: null,
  },
  [AccountInfoSection.businessInfo]: {
    testId: 'ACCOUNT_INFO_PAGE.BUSINESS_INFO',
    template: 'business-info',
    link: './edit-business-info',
    linkText: REGULAR_TRANSLATIONS.change,
    linkIcon: ICONS_NAMES.editSmall,
    data: null,
  },
  [AccountInfoSection.password]: {
    testId: 'ACCOUNT_INFO_PAGE.PASSWORD',
    title: REGULAR_TRANSLATIONS.password,
    link: './change-password',
    linkText: REGULAR_TRANSLATIONS.change,
    linkIcon: ICONS_NAMES.editSmall,
    linkAlignment: 'center',
    content: '********',
  },
  [AccountInfoSection.email]: {
    testId: 'ACCOUNT_INFO_PAGE.EMAIL',
    title: REGULAR_TRANSLATIONS.email,
    link: './change-email',
    linkText: REGULAR_TRANSLATIONS.change,
    linkIcon: ICONS_NAMES.editSmall,
    linkAlignment: 'center',
    content: '',
  },
  [AccountInfoSection.cardNumber]: {
    testId: 'ACCOUNT_INFO_PAGE.CARD_NUMBER',
    title: REGULAR_TRANSLATIONS.cardNumber,
    content: '',
  },
};

export const FRAGMENT_EXPIRED_CHANGE_EMAIL_LINK = 'expired_secret';
